export default __webpack_public_path__ + "static/media/farmer2.c19cac01.png";